import React, { useEffect, useCallback, useRef } from 'react';
import useRequest from '@hooks/useRequest';
import { makeStyles } from '@material-ui/core';
import { FormProvider, useForm } from 'react-hook-form';
import ConsultMethodControl from './FormComponents/ConsultMethodControl';
import { ConsultingStartMethodForm } from './types';
import { DesignStepProps } from './RequestTypes/DesignStepRequest/types';

const ConsultingStartMethodStep: React.FC<DesignStepProps> = ({
  setDisabledNextButton,
  nextButtonAction
}) => {
  const { requestContainer } = useDesignRequestStyles();
  const { onUpdateRfqInfo, consultingStartMethod } = useRequest();

  const formProps = useForm<ConsultingStartMethodForm>({
    mode: 'onChange',
    defaultValues: {
      consultingStartMethod
    }
  });
  const { watch } = formProps;
  const { consultingStartMethod: currentConsultingStartMethod } = watch();
  const currentFormValue = useRef<ConsultingStartMethodForm>({
    consultingStartMethod: currentConsultingStartMethod
  });

  const onSubmit = useCallback(() => {
    const currentValue = currentFormValue.current;
    onUpdateRfqInfo({
      ...currentValue
    });
  }, [onUpdateRfqInfo]);

  useEffect(() => {
    currentFormValue.current = {
      consultingStartMethod
    };
  }, [consultingStartMethod]);

  useEffect(() => {
    nextButtonAction.current.DESIGN = onSubmit;
  }, [nextButtonAction, onSubmit]);

  useEffect(() => {
    if (!setDisabledNextButton) return;

    if (consultingStartMethod !== null) {
      if (consultingStartMethod) {
        setDisabledNextButton(false);
        return;
      }
    }
  }, [consultingStartMethod, setDisabledNextButton]);

  useEffect(() => {
    return onSubmit;
    //eslint-disable-next-line
  }, []);

  return (
    <div className={requestContainer}>
      <FormProvider {...formProps}>
        <form>
          <ConsultMethodControl />
        </form>
      </FormProvider>
    </div>
  );
};

export default ConsultingStartMethodStep;

const useDesignRequestStyles = makeStyles((theme) => ({
  requestContainer: {
    width: '100%',
    maxWidth: '464px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '72px',
    [theme.breakpoints.down('sm')]: {
      paddingTop: 0
    }
  }
}));
